/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {toast} from 'react-toastify'
import * as actions from '../redux/BudgetAction'
import {Budget} from '../models/BudgetModel'

interface Props {
  show: boolean
  handleClose: () => void
  budget: Budget
}

export const BudgetApproveConfirmModal: FC<Props> = ({show, handleClose, budget}) => {
  const [loading, setLoading] = useState(false)
  let navigate = useNavigate()
  const dispatch: any = useDispatch()

  const approveBudget = () => {
    setLoading(true)
    dispatch(actions.approve(budget?._id))
      .then((response: any) => {
        toast.success(response)
        setLoading(false)
        navigate('/budgets')
      })
      .catch((error: any) => {
        toast.error(error)
        setLoading(false)
      })
    handleClose()
  }

  return (
    <>
      <Modal
        id='kt_modal_delete_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-500px h-auto'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h2>Approve Budget</h2>
          </div>

          <div className='modal-body flex-row-fluid py-lg-10 px-lg-10'>
            <p className='d-flex align-items-center fs-5 fw-bold'>
              Are you sure you want to approve this budget ({budget?.title})?
            </p>
            <div className='d-flex flex-stack mt-5'>
              <button
                type='button'
                className='btn btn-lg btn-light-primary me-3'
                onClick={() => {
                  handleClose()
                }}
              >
                Cancel
              </button>

              <button
                type='button'
                className='btn btn-lg btn-primary'
                onClick={() => {
                  approveBudget()
                }}
                disabled={loading}
              >
                <span className='indicator-label'>{loading ? 'Approving...' : 'Approve'}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
